import publicRequest from "./publicRequest";

const postError = (data) =>
  process.env.NODE_ENV === "production" &&
  publicRequest({
    route: "/error",
    data,
    useAPI: false,
  });

export default postError;
